import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50/80">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-lg">17</span>
              </div>
              <span className="font-bold text-lg text-background-50">每日大赛</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60">
              每天参赛赢好礼，17c每日大赛是专为玩家打造的每日竞技互动平台。错过今天还有明天，天天有惊喜！
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/jingji-saishi" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">赛事分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">赛事类型</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/jingji-saishi" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">竞技赛事</Link>
              </li>
              <li>
                <Link to="/category/xiuxian-tiaozhan" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">休闲挑战</Link>
              </li>
              <li>
                <Link to="/category/zhishi-jingsai" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">知识竞赛</Link>
              </li>
              <li>
                <Link to="/category/tuandui-lianmeng" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">团队联盟</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-50/60">
              <li>
                <i className="ri-mail-line mr-2"></i>contact@17c.com
              </li>
              <li>
                <i className="ri-phone-line mr-2"></i>400-888-1717
              </li>
              <li>
                <i className="ri-map-pin-line mr-2"></i>北京市朝阳区科技园路17号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; 2024-2026 17c每日大赛 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50 transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}